import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class WorkspaceModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (WorkspaceModel._instance == null) WorkspaceModel._instance = new WorkspaceModel(authManager);
        return WorkspaceModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'projects/workspaces');

        this.entityName = 'projects.Workspace';
        this.privileges = {
            create: [["adminWorkspace"],["manageWorkspace"]],
            read: [["adminWorkspace"],["manageWorkspace"],["editWorkspace"],["readWorkspace"]],
            update: [["adminWorkspace"],["manageWorkspace"],["editWorkspace"]],
            delete: [["adminWorkspace"],["manageWorkspace"]],
        };

        this.label = 'Workspace';
        this.setLabel = 'Workspaces';

        this.browser = {
            name: 'default-projects-workspace-browser',
            moduleName: 'default-projects-workspace-browser',
            moduleTitle: 'Workspaces',
            moduleStateSlotName: 'default-projects-workspace-browser',
        };

        this.editor = {
            name: 'default-projects-workspace-editor',
            moduleName: 'default-projects-workspace-editor',
            moduleTitle: 'Workspace',
            moduleStateSlotName: 'default-projects-workspace-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'ownerId',
                type: 'User',
                persistent: true,
                label: 'Owner',
            },
            {
                name: 'ownerLabel',
                type: 'string',
                persistent: false,
                label: 'Owner',
                distinctLabel: 'Owner (Text)',
                readOnly: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
